import { useEffect } from 'react';

/**
 * Custom hook to set the document title
 * @param title - The title to set for the page
 * @param suffix - Optional suffix (defaults to "CampusConnect")
 */
export function useDocumentTitle(title: string, suffix: string = 'CampusConnect') {
  useEffect(() => {
    const previousTitle = document.title;
    
    // Set the new title with suffix
    document.title = title ? `${title} - ${suffix}` : suffix;
    
    // Cleanup function to restore previous title
    return () => {
      document.title = previousTitle;
    };
  }, [title, suffix]);
}

export default useDocumentTitle;